import React from 'react';
import { Layout } from '../components/Layout';
export function PhysicalRegistration() {
  return <Layout data-id="element-329">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-330">
        <h1 className="text-4xl font-bold text-voices-navy mb-6" data-id="element-331">
          Physical Registration
        </h1>
        <p className="text-lg text-gray-700 mb-8" data-id="element-332">
          Register to attend Voices Live 2026 in person at The Somi Place,
          Lekki.
        </p>
        <form className="bg-white p-8 rounded-xl shadow-md border border-gray-200 max-w-2xl mx-auto" data-id="element-333">
          <div className="space-y-6" data-id="element-334">
            <div data-id="element-335">
              <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-336">
                Full Name
              </label>
              <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-gold focus:border-voices-gold" placeholder="Enter your full name" data-id="element-337" />
            </div>
            <div data-id="element-338">
              <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-339">
                Email Address
              </label>
              <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-gold focus:border-voices-gold" placeholder="Enter your email address" data-id="element-340" />
            </div>
            <div data-id="element-341">
              <label htmlFor="phone" className="block text-gray-700 font-medium mb-2" data-id="element-342">
                Phone Number
              </label>
              <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-gold focus:border-voices-gold" placeholder="Enter your phone number" data-id="element-343" />
            </div>
            <button type="submit" className="w-full bg-voices-gold text-white px-6 py-3 rounded-lg font-semibold hover:bg-yellow-600 transition-colors" data-id="element-344">
              Complete Registration
            </button>
          </div>
        </form>
      </div>
    </Layout>;
}